import { z } from 'zod'

export const MAX_LISTS_PER_USER = 5
export const MAX_ITEMS_PER_LIST = 10

const bookListItemSchema = z.object({
  bookId: z.string().min(1, 'Book ID is required'),
})

export const createBookListSchema = z.object({
  title: z.string().min(1, 'Title is required').max(100, 'Title must be 100 characters or less'),
  description: z.string().max(2000, 'Description must be 2000 characters or less').nullable().optional(),
  genreId: z.string().min(1).nullable().optional(),
  items: z
    .array(bookListItemSchema)
    .min(1, 'At least one book is required')
    .max(MAX_ITEMS_PER_LIST, `Maximum ${MAX_ITEMS_PER_LIST} books per list`),
})

export const updateBookListSchema = z.object({
  title: z.string().min(1, 'Title is required').max(100, 'Title must be 100 characters or less').optional(),
  description: z.string().max(2000, 'Description must be 2000 characters or less').nullable().optional(),
  genreId: z.string().min(1).nullable().optional(),
  items: z
    .array(bookListItemSchema)
    .min(1, 'At least one book is required')
    .max(MAX_ITEMS_PER_LIST, `Maximum ${MAX_ITEMS_PER_LIST} books per list`)
    .optional(),
})

export type CreateBookListInput = z.infer<typeof createBookListSchema>
export type UpdateBookListInput = z.infer<typeof updateBookListSchema>
